export default {
    'ToolsCompliantListAdd': ['ToolsCompliantList', 'routerName3'],
};
